import type { PageRoutine, RoutineSource } from './routine'

export type RoutineRegistry = {
  register: (source: RoutineSource) => () => void
  current: () => PageRoutine | undefined
}

export function createRoutineRegistry(): RoutineRegistry {
  const stack: RoutineSource[] = []

  return {
    register: source => {
      if (!stack.includes(source)) stack.push(source)

      return () => {
        const index = stack.lastIndexOf(source)
        if (index !== -1) stack.splice(index, 1)
      }
    },
    current: () => {
      const source = stack[stack.length - 1]
      return source ? source() : undefined
    },
  }
}
